import { EModuleWidth } from 'src/types/common/module';

const moduleStyleProps = (moduleWidth) => {
  //const isModuleWidthNone = moduleWidth === EModuleWidth.NONE;

  const isModuleWidthFull = moduleWidth === EModuleWidth.FULL;
  return {
    hideBkgColor: isModuleWidthFull,
    hideBkgConfig: isModuleWidthFull, // || isModuleWidthNone,
  };
};

export { moduleStyleProps };
